import Scenario from "./config/Scenario";

const GamepadApp = () => {
    // const { scenario } = useGamepadSession();
    return (Scenario["game"].gamepad)
}

export default GamepadApp;
